import { render, staticRenderFns } from "./changeAvatar.vue?vue&type=template&id=44c0434b&"
import script from "./changeAvatar.vue?vue&type=script&lang=js&"
export * from "./changeAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports